































































import { DateTime } from 'luxon';
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { InputResponse } from '@/constants/form/types';

@Component({})
export default class DatePicker extends Vue {
  // デートピッカーのname属性
  @Prop({ default: '' })
  private name!: string;
  // デートピッカーの初期値
  @Prop({ default: '' })
  private value?: string;
  // デートピッカーの表示タイプ初期値
  @Prop({ default: 'date' })
  private type?: string;
  // デートピッカーの表示形式
  @Prop({ default: '' })
  private format?: string;
  // 入力要素名
  @Prop({ default: '' })
  private label?: string;
  // プレースホルダ―
  @Prop({ default: '' })
  private placeholder?: string;
  // デートピッカーを入力可能か否か
  @Prop({ default: false })
  private isDisabled?: boolean;
  // readonly
  @Prop({ default: false })
  private isReadonly?: boolean;
  // デートピッカー内選択ボタン色 (参考：https://vuetifyjs.com/ja/styles/colors/#sass-)
  @Prop({ default: 'grey' })
  private sendTextColor?: string;
  @Prop({ default: 'primary' })
  private primary?: string;
  // デートピッカー内の選択可能な過去日を指定
  @Prop({ default: '' })
  private minDate?: string;
  // デートピッカー内の選択可能な未来日を指定
  @Prop({ default: '' })
  private maxDate?: string;
  @Prop({ default: '' })
  private rule?: string;
  // 誕生日用ピッカーか否か
  @Prop({ default: false })
  private isBirthday?: boolean;
  // 入力クリア機能の使用可否
  @Prop({ default: false })
  private isClearable?: boolean;
  // デートピッカー用形式
  public date: string | null = '';
  // 表示用形式
  public formatDate = '';
  public menu = false;
  // 選択日付け範囲
  public localMinDate = '';
  public localMaxDate = '';
  public pickerDate: string | undefined = '';

  mounted() {
    if (this.value !== undefined && this.value !== null && this.value.length > 0) {
      this.date = this.value;
    }
    if (this.minDate !== undefined && this.minDate !== null && this.minDate.length > 0) {
      this.localMinDate = this.minDate;
    }
    if (this.maxDate !== undefined && this.maxDate !== null && this.maxDate.length > 0) {
      this.localMaxDate = this.maxDate;
    }
    if (this.isBirthday) {
      // 誕生日用ピッカー設定
      this.pickerDate = '1990-01-01';
      this.localMinDate = '1950-01-01';
      this.localMaxDate = DateTime.local().toString();
    }
  }

  @Watch('value')
  watchValue() {
    if (this.value !== undefined && this.value !== null && this.value.length > 0) {
      this.date = this.value;
    }
    if (this.minDate !== undefined && this.minDate !== null && this.minDate.length > 0) {
      this.localMinDate = this.minDate;
    }
    if (this.maxDate !== undefined && this.maxDate !== null && this.maxDate.length > 0) {
      this.localMaxDate = this.maxDate;
    }
  }

  // デートピッカー用値が更新されたら表示用値を更新
  @Watch('date')
  updateDate() {
    this.formatDate = this.editDateFormat(this.date, 'Asia/Tokyo', this.format);
  }
  // 選択対象日付け（Start）の変更監視（主にフォームリセット対策）
  @Watch('minDate')
  updateMinDate() {
    this.localMinDate = this.minDate !== undefined ? this.minDate : '' ;
  }
  // 選択対象日付け（End）の変更監視（主にフォームリセット対策）
  @Watch('maxDate')
  updateMaxDate() {
    this.localMaxDate = this.maxDate !== undefined ? this.maxDate : '' ;
  }
  // フォームリセット時など値が変更されたとき各ローカルデータリセット
  @Watch('formatDate')
  updateformatDate() {
    if (this.formatDate === undefined) {
      this.date = '';
      this.localMinDate = '';
      this.localMaxDate = '';
    }
  }
  // 誕生日入力の場合のピッカー設定
  @Watch('menu')
  settingBirthdayPicker() {
    this.isBirthday && this.menu && setTimeout(() => {
        // this.$refs.picker.pickerDate = 'YEAR'
        // の書式の場合、TypeScriptエラーになるため以下の書式とする
        const picker: any = this.$refs.picker;
        picker.activePicker = 'YEAR';
        this.pickerDate = '';
      });
  }

  /**
   * 入力値をクリアする
   */
  clearDateOperation() {
    this.date = null;
    this.selectDateOpratipon(this.$refs, this.date);
    if (this.isBirthday) this.pickerDate = '1990-01-01';
  }

  /**
   * 親コンポーネントに値を通知する
   * @module selectDateOpratipon
   * @param {any} $refs
   * @param {string} date 選択した日付け
   * @return {[k: string]: string} - input要素名と値（返却はデートピッカー形式）
   */
  @Emit('selectDateOpratipon')
  public selectDateOpratipon($refs: any, date: string | null): InputResponse {
    $refs.menu.save(date);
    return { name: this.name, value: this.date };
  }

  /**
   * Date型のフォーマット変更を行います
   * @param {string} date - 日付け文字列
   * @param {string} zone - タイムゾーン
   * @param {string} format - フォーマット
   * @returns string - フォーマットを変更した日付け文字列
   */
  public editDateFormat(date: string | null, zone: string, format?: string): string{
    if (
      date === null ||
      date === undefined ||
      typeof date !== 'string' ||
      (typeof date === 'string' && date === '')
    ) return '';
    const datetime = DateTime.fromISO(date).setZone(zone);
    return !format || format.length === 0 ? date : datetime.toFormat(format);
  }
}
